import {SeniorityDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateSeniority(
    userData: Record<string, string>,
    seniorityId: number,
    update: Record<string, any>
) {
    try {
        const result = await SeniorityDao.updateSeniority(userData.userToken, seniorityId, update);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
